import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useTrendingMovies, usePopularMovies } from '../hooks/useMovies'
import { useWatchedMovies, useWatchlist, useUserStats } from '../hooks/useFirestore'
import MovieGrid from '../components/movie/MovieGrid'
import MovieCard from '../components/movie/MovieCard'
import './Home.css'

function Home() {
  const { user } = useAuth()
  const { movies: trending, loading: trendingLoading } = useTrendingMovies()
  const { movies: popular, loading: popularLoading } = usePopularMovies()
  const { movies: recentWatched, loading: watchedLoading } = useWatchedMovies()
  const { movies: watchlist, loading: watchlistLoading } = useWatchlist()
  const { stats } = useUserStats()

  return (
    <div className="page home-page">
      <div className="container">
        {/* Welcome Section */}
        <section className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">
              Hola, <span className="accent">{user?.displayName?.split(' ')[0]}</span> 👋
            </h1>
            <p className="hero-subtitle">
              ¿Qué película vas a ver hoy?
            </p>
            <Link to="/search" className="btn btn-primary btn-lg">
              🔍 Buscar películas
            </Link>
          </div>

          {stats && (
            <div className="stats-cards">
              <div className="stat-card">
                <span className="stat-value">{stats.totalMovies}</span>
                <span className="stat-label">Películas vistas</span>
              </div>
              <div className="stat-card">
                <span className="stat-value">{stats.totalHours}h</span>
                <span className="stat-label">Tiempo total</span>
              </div>
              <div className="stat-card">
                <span className="stat-value">{stats.averageRating}</span>
                <span className="stat-label">Puntuación media</span>
              </div>
            </div>
          )}
        </section>

        {/* Download App Section - Only show on web */}
        {!window.electronAPI && (
          <section className="download-section">
            <div className="download-content">
              <div className="download-info">
                <h2>📱 Descarga la App</h2>
                <p>Disfruta de una experiencia completa con TV en vivo, torrents y más.</p>
              </div>
              <div className="download-buttons">
                <a 
                  href="https://github.com/ortegapedro88/movie-tracker/releases/latest/download/Pedrazo.Movie.Tracker-1.0.0-arm64.dmg" 
                  className="download-btn macos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="os-icon"></span>
                  <span className="os-text">
                    <span className="os-name">macOS</span>
                    <span className="os-arch">Apple Silicon</span>
                  </span>
                </a>
                <a 
                  href="https://github.com/ortegapedro88/movie-tracker/releases/latest/download/Pedrazo.Movie.Tracker-1.0.0.dmg" 
                  className="download-btn macos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="os-icon"></span>
                  <span className="os-text">
                    <span className="os-name">macOS</span>
                    <span className="os-arch">Intel</span>
                  </span>
                </a>
                <a 
                  href="https://github.com/ortegapedro88/movie-tracker/releases/latest/download/Pedrazo.Movie.Tracker.Setup.1.0.0.exe" 
                  className="download-btn windows"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="os-icon">🪟</span>
                  <span className="os-text">
                    <span className="os-name">Windows</span>
                    <span className="os-arch">64-bit</span>
                  </span>
                </a>
                <a 
                  href="https://github.com/ortegapedro88/movie-tracker/releases/latest/download/Pedrazo.Movie.Tracker-1.0.0.AppImage" 
                  className="download-btn linux"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="os-icon">🐧</span>
                  <span className="os-text">
                    <span className="os-name">Linux</span>
                    <span className="os-arch">AppImage</span>
                  </span>
                </a>
              </div>
            </div>
          </section>
        )}

        {/* Recently Watched */}
        {recentWatched.length > 0 && (
          <section className="section">
            <div className="section-header">
              <h2 className="section-title">📋 Vistas recientemente</h2>
              <Link to="/history" className="section-link">Ver todo →</Link>
            </div>
            <div className="movie-row">
              {recentWatched.slice(0, 6).map((movie) => (
                <MovieCard key={movie.id} movie={movie} showRating userRating={movie.rating} />
              ))}
            </div>
          </section>
        )}

        {/* Watchlist */}
        {watchlist.length > 0 && (
          <section className="section">
            <div className="section-header">
              <h2 className="section-title">🎯 Tu lista para ver</h2>
              <Link to="/watchlist" className="section-link">Ver todo →</Link>
            </div>
            <div className="movie-row">
              {watchlist.slice(0, 6).map((movie) => (
                <MovieCard key={movie.id} movie={movie} showWatchWith={true} />
              ))}
            </div>
          </section>
        )}

        {/* Trending */}
        <section className="section">
          <div className="section-header">
            <h2 className="section-title">🔥 Tendencias de la semana</h2>
          </div>
          <MovieGrid 
            movies={trending.slice(0, 12)} 
            loading={trendingLoading}
            emptyMessage="No hay tendencias disponibles"
          />
        </section>

        {/* Popular */}
        <section className="section">
          <div className="section-header">
            <h2 className="section-title">⭐ Populares ahora</h2>
          </div>
          <MovieGrid 
            movies={popular.slice(0, 12)} 
            loading={popularLoading}
            emptyMessage="No hay películas populares disponibles"
          />
        </section>
      </div>
    </div>
  )
}

export default Home
